import React from "react";
import { Button } from "react-bootstrap";
import WarningModal from "../WarningModal";
import { isNull } from "lodash";

const DeleteWarning = ({
  showModal,
  DeleteToastMessage,
  DeleteToastMessageHead = null,
  handleConfirmClick,
  handleCancelClick,
  cancelButtonText = "No, Cancel",
  removeButtonText = "Delete",
  isApproval = false,
}) => {
  return (
    <WarningModal
      show={showModal}
      onHide={handleCancelClick}
      DeleteToastMessage={DeleteToastMessage}
      DeleteToastMessageHead={DeleteToastMessageHead}
    >
      <div className="msg-headtext">
        {!isNull(DeleteToastMessageHead) && (
          <h4 style={{ paddingRight: "50px" }}>{DeleteToastMessageHead}</h4>
        )}
        <div style={{ marginBottom: "10px" }}>
          <p>{DeleteToastMessage} </p>
          {!isApproval && <p>Do you wish to delete?</p>}
        </div>

        <div className={!isApproval && "btnsDeleteCancel"}>
          <Button
            className={`${isApproval && "mr-5"} cancelButtonWarning`}
            onClick={handleCancelClick}
          >
            {cancelButtonText}
          </Button>
          <Button className="removeButtonWarning" onClick={handleConfirmClick}>
            {removeButtonText}
          </Button>
        </div>
      </div>
    </WarningModal>
  );
};

export default DeleteWarning;
